<template>
    <div>
        <PageHeader>
            <h2>Strutture configurate</h2>
            <el-button type="primary" @click="selectedTermsFile = null; showUploadTermsDialog = true">
                <font-awesome-icon icon="upload" style="margin-right: 8px;"/>
                <b>Carica nuovi termini di servizio</b></el-button>
            <el-button type="success" @click="addOrganization">
                <font-awesome-icon icon="plus" style="margin-right: 8px;"/>
                <b>Configura nuova struttura</b></el-button>
        </PageHeader>

        <el-table :data="items" stripe border style="width: 100%" v-loading="isBusy">
            <el-table-column prop="organizationId" label="ID">
                <template #default="scope">
                    <b>{{ scope.row.organizationId }}</b>
                </template>
            </el-table-column>
            <el-table-column prop="name" label="Nome">
                <template #default="scope">
                    <b>{{ scope.row.name }}</b>
                </template>
            </el-table-column>
            <el-table-column prop="wlextHost" label="WLext Host"/>
            <el-table-column prop="wlextOrganizationId" label="WLext Organization ID"/>
            <el-table-column prop="logo" label="Logo">
                <template #default="scope">
                    <img v-if="scope.row.logo !== null" :src="'data:image/png;base64,' + scope.row.logo" alt=""
                         style="max-height: 45px;">
                    <span v-else>Nessun logo impostato</span>
                </template>
            </el-table-column>
            <el-table-column label="Attiva">
                <template #default="scope">
                    <el-switch v-model="scope.row.isActive" @change="updateOrganizationIsActive(scope.row)"></el-switch>
                </template>
            </el-table-column>
            <el-table-column prop="categories" label="Categorie" align="center" width="100">
                <template #default="scope">
                    <el-tag>{{ scope.row.categories.length }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="usersAssociated" label="Utenti associati" align="center" width="140">
                <template #default="scope">
                    <el-tag>{{ scope.row.usersAssociated }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="lastMonthSignups" label="Registrazioni (ultimi 30 giorni)" align="center"
                             width="150">
                <template #default="scope">
                    <el-tag>{{ scope.row.lastMonthSignups }}</el-tag>
                    <el-button style="margin-left: 8px;" size="small" @click="showSignupsDetails(scope.row)">Dettagli
                    </el-button>
                </template>
            </el-table-column>
            <el-table-column prop="lastMonthDownloads" label="Download (ultimi 30 giorni)" align="center" width="150">
                <template #default="scope">
                    <el-tag>{{ scope.row.lastMonthDownloads }}</el-tag>
                    <el-button style="margin-left: 8px;" size="small" @click="showDownloadsDetails(scope.row)">
                        Dettagli
                    </el-button>
                </template>
            </el-table-column>
            <el-table-column label="Operazioni" width="140" align="center">
                <template #default="scope">
                    <el-button-group>
                        <el-button type="primary" @click="editOrganization(scope.row)">
                            <font-awesome-icon icon="pencil"/>
                        </el-button>
                        <el-button type="danger" @click="deleteOrganization(scope.row)">
                            <font-awesome-icon icon="trash"/>
                        </el-button>
                    </el-button-group>
                </template>
            </el-table-column>
        </el-table>

        <el-dialog v-if="showUploadTermsDialog" v-model="showUploadTermsDialog"
                   title="Carica nuovi termini di servizio"
                   width="400" :close-on-click-modal="!isDialogBusy" :close-on-press-escape="!isDialogBusy">
            <input type="file" @change="parseFile">
            <template #footer>
                <div class="dialog-footer">
                    <el-button @click="showUploadTermsDialog = false">Annulla</el-button>
                    <el-button type="success" :loading="isDialogBusy" :disabled="selectedTermsFile === null"
                               @click="uploadTerms">
                        Carica
                    </el-button>
                </div>
            </template>
        </el-dialog>

        <el-dialog v-if="selectedOrganization !== null && showDialog" v-model="showDialog"
                   :title="selectedOrganization!.id === '' ? 'Configura nuova struttura' : 'Modifica struttura'"
                   width="800">
            <el-steps style="margin-bottom: 20px;" :active="dialogActiveStep" finish-status="success">
                <el-step title="Informazioni generali"/>
                <el-step title="Configurazione categorie"/>
                <el-step title="Disponibilità documenti"/>
            </el-steps>
            <div v-if="dialogActiveStep === 0">
                <el-form :model="selectedOrganization" label-position="top">
                    <div style="display: grid; grid-template-columns: 1fr 200px; column-gap: 20px;">
                        <el-form-item label="Codice struttura" required>
                            <el-input v-model="selectedOrganization.organizationId" autocomplete="off"/>
                        </el-form-item>
                        <el-form-item label="Nome" required>
                            <el-input v-model="selectedOrganization.name" autocomplete="off"/>
                        </el-form-item>
                    </div>
                    <div style="display: grid; grid-template-columns: 1fr 200px; column-gap: 20px;">
                        <el-form-item label="WLext Host" required>
                            <el-input v-model="selectedOrganization.wlextHost"/>
                        </el-form-item>
                        <el-form-item label="WLext Organization ID">
                            <el-input v-model="selectedOrganization.wlextOrganizationId"/>
                        </el-form-item>
                    </div>
                    <div v-if="!isEditing" style="display: flex; column-gap: 20px;">
                        <el-form-item style="flex: 1;" label="Username" required>
                            <el-input v-model="selectedOrganizationAdmin.username"/>
                        </el-form-item>
                        <el-form-item style="flex: 1;" label="Password" required>
                            <el-input v-model="selectedOrganizationAdmin.password"/>
                        </el-form-item>
                    </div>
                    <div v-else style="display: flex; column-gap: 20px;">
                        <el-form-item style="flex: 1;" label="Username" required>
                            <el-input v-model="selectedOrganization.admin.username"/>
                        </el-form-item>
                        <el-form-item style="flex: 1;" label="Password">
                            <el-button @click="changePassword">
                                Modifica password
                            </el-button>
                        </el-form-item>
                    </div>
                    <el-form-item label="Logo">
                        <div style="display: flex; flex-direction: column; row-gap: 20px;">
                            <img v-if="selectedOrganization.logo !== null"
                                 :src="'data:image/png;base64,' + selectedOrganization.logo" width="300px" alt="">
                            <el-button-group>
                                <el-button @click="loadImage">{{
                                        selectedOrganization.logo === null ?
                                            "Carica..." : "Modifica..."
                                    }}
                                </el-button>
                                <el-button v-if="selectedOrganization.logo !== null" type="danger" plain
                                           @click="selectedOrganization.logo = null">Elimina
                                </el-button>
                            </el-button-group>
                            <input id="input1" style="display: none;" type="file" @change="parseImage"/>
                        </div>
                    </el-form-item>
                    <el-form-item label="Testo personalizzato di invito">
                        <el-input type="textarea" v-model="selectedOrganization.customInvitationText"/>
                    </el-form-item>
                </el-form>
            </div>
            <div v-else-if="dialogActiveStep === 1">
                <el-form label-position="top">
                    <!--                    <el-form-item label="Rendi disponibili i documenti fino a:">-->
                    <!--                        <el-input-number v-model="selectedOrganization.documentAvailabilityDays" :min="1" /><span-->
                    <!--                            style="margin-left: 10px;">giorni</span>-->
                    <!--                    </el-form-item>-->
                    <el-form-item label="Seleziona le categorie documentali:">
                        <div style="display: flex; flex-direction: column; row-gap: 8px; width: 100%;">
                            <div
                                style="display: grid; grid-template-columns: auto 1fr auto; column-gap: 8px; align-items: center; width: 100%;">
                                <el-tag round size="large"><b>{{ categories.filter(x => x.selected).length }}</b>
                                </el-tag>
                                <el-input placeholder="Filtra le categorie..." v-model="categoryFilter"
                                          clearable></el-input>
                                <el-button-group>
                                    <el-button @click="categories.forEach(x => x.selected = true)">Seleziona
                                        tutte
                                    </el-button>
                                    <el-button @click="categories.forEach(x => x.selected = false)">Deseleziona
                                        tutte
                                    </el-button>
                                </el-button-group>
                            </div>
                            <div
                                style="display: flex; flex-wrap: wrap; align-items: center; column-gap: 8px; row-gap: 8px;">
                                <el-checkbox v-for="category in categories" :key="category.id"
                                             v-model="category.selected" :label="category.name" size="large" border
                                             style="margin: 0;"
                                             :style="{ display: getCategoryCheckboxStyle(category) }"/>
                            </div>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <div v-else>
                <el-table :data="categories.filter(x => x.selected)" stripe>
                    <el-table-column prop="name" label="Nome categoria"/>
                    <el-table-column label="Disponibilità documenti">
                        <template #default="scope">
                            <el-input-number v-model="scope.row.availabilityDays" :min="0"/>
                            giorni
                            <div><small><i>Inserire 0 per non limitare la disponibilità dei documenti</i></small></div>
                        </template>
                    </el-table-column>
                    <el-table-column label="Condizioni">
                        <template #default="scope">
                            <el-checkbox-group v-model="scope.row.conditions">
                                <el-checkbox label="PREOSP" value="PREOSP"/>
                                <el-checkbox label="PACC" value="PACC"/>
                                <el-checkbox label="REP" value="REP"/>
                                <el-checkbox label="AMB" value="AMB"/>
                                <el-checkbox label="PS" value="PS"/>
                                <el-checkbox label="LIS" value="LIS"/>
                            </el-checkbox-group>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <template #footer>
                <div class="dialog-footer">
                    <el-button @click="dialogActiveStep === 0 ? showDialog = false : dialogActiveStep -= 1">{{
                            dialogActiveStep === 0 ? "Annulla" : "Indietro"
                        }}
                    </el-button>
                    <el-button type="success" :loading="isDialogBusy"
                               @click="dialogActiveStep === 2 ? saveOrganization() : continueSavingOrganization()">
                        {{ dialogActiveStep === 2 ? "Salva" : "Continua" }}
                    </el-button>
                </div>
            </template>
        </el-dialog>

        <el-dialog v-if="selectedOrganization !== null && showSignupsDetailsDialog" v-model="showSignupsDetailsDialog" width="500"
                   title="Dettagli registrazioni">
            <el-table :data="selectedOrganization.signupsCounter" stripe border style="width: 100%" max-height="500"
                      show-summary
                      :summary-method="getSummaries">
                <el-table-column label="Data di riferimento">
                    <template #default="scope">
                        <b>{{ scope.row.refDate }}</b>
                    </template>
                </el-table-column>
                <el-table-column prop="count" label="Registrazioni" align="center">
                    <template #default="scope">
                        <el-tag>{{ scope.row.count }}</el-tag>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>

        <el-dialog v-if="selectedOrganization !== null && showDownloadsDetailsDialog" v-model="showDownloadsDetailsDialog" width="500"
                   title="Dettagli download">
            <el-table :data="selectedOrganization.downloadsCounter" stripe border style="width: 100%" max-height="500"
                      show-summary
                      :summary-method="getSummaries">
                <el-table-column label="Data di riferimento">
                    <template #default="scope">
                        <b>{{ scope.row.refDate }}</b>
                    </template>
                </el-table-column>
                <el-table-column prop="count" label="Download" align="center">
                    <template #default="scope">
                        <el-tag>{{ scope.row.count }}</el-tag>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>

<script lang="ts">
import VueBase from "@/components/VueBase";
import PageHeader from "@/components/PageHeader.vue";
import {Options} from "vue-class-component";
import OrganizationService from "@/services/OrganizationService";
import Organization from "@/types/Organization";
import {ElMessage, ElMessageBox} from "element-plus";
import CategoryService from "@/services/CategoryService";
import Category from "@/types/Category";
import {DateTime} from "luxon";
import {h, VNode} from "vue";
import TermsService from "@/services/TermsService";
import AdminService from "@/services/AdminService";

@Options({
    computed: {
        DateTime() {
            return DateTime
        }
    },
    components: {
        PageHeader
    }
})
export default class OrganizationsView extends VueBase {
    items: Organization[] = [];
    showUploadTermsDialog: boolean = false;
    showDialog: boolean = false;
    showSignupsDetailsDialog: boolean = false;
    showDownloadsDetailsDialog: boolean = false;
    selectedOrganization: Organization | null = null;
    selectedOrganizationAdmin: { username: string, password: string} = {username: "", password: ""};
    dialogActiveStep: number = 0;
    categories: Category[] = [];
    isDialogBusy: boolean = false;
    categoryFilter: string = "";
    selectedTermsFile: string | null = null;
    isEditing: boolean = false;

    async mounted() {
        await this.getOrganizations();
    }

    async getOrganizations() {
        this.isBusy = true;
        try {
            this.items = await OrganizationService.getOrganizations();
        } catch (error: any) {
            ElMessage.error({message: error.message});
        }
        this.isBusy = false;
    }

    showSignupsDetails(organization: Organization) {
        this.selectedOrganization = organization;
        this.showSignupsDetailsDialog = true;
    }

    showDownloadsDetails(organization: Organization) {
        this.selectedOrganization = organization;
        this.showDownloadsDetailsDialog = true;
    }

    getSummaries(param: any) {
        const {columns, data} = param;
        const sums: (string | VNode)[] = []

        columns.forEach((column: any, index: number) => {
            if (index === 0) {
                sums[index] = h("b", {}, ["Totale"]);
                return;
            }
            const values = data.map((item: any) => Number(item[column.property]));
            if (!values.every((value: any) => Number.isNaN(value))) {
                const tot = values.reduce((prev: any, curr: any) => {
                    const value = Number(curr);
                    if (!Number.isNaN(value)) {
                        return prev + curr;
                    } else {
                        return prev;
                    }
                }, 0);
                sums[index] = h("span", {class: "el-tag el-tag--primary el-tag--light"}, [
                    h("b", {}, [tot])
                ]);
            } else {
                sums[index] = "N/A";
            }
        });

        return sums;
    }

    async deleteOrganization(organization: Organization) {
        ElMessageBox.confirm("Sei sicuro di voler eliminare la struttura selezionata?", {
            title: "Attenzione",
            cancelButtonText: "Annulla",
            confirmButtonText: "Elimina"
        })
            .then(async () => {
                this.isBusy = true;
                try {
                    await OrganizationService.deleteOrganization(organization);
                    await this.getOrganizations();
                } catch (error: any) {
                    ElMessage.error({message: error.message});
                }
                this.isBusy = false;
            })
            .catch(() => {
            });
    }

    async editOrganization(organization: Organization) {
        this.isEditing = true;
        this.selectedOrganization = {...organization};
        this.dialogActiveStep = 0;
        this.showDialog = true;
    }

    parseFile(event: any) {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = (e: any) => {
                this.selectedTermsFile = e.target.result.split(",")[1];
            };
            reader.readAsDataURL(file);
        }
    }

    async uploadTerms() {
        this.isDialogBusy = true;
        try {
            await TermsService.uploadTerms(this.selectedTermsFile!);
            this.showUploadTermsDialog = false;
            alert("I nuovi termini di servizio sono stati caricati con successo");
        } catch (error: any) {
            ElMessage.error({message: error.message});
        }
        this.isDialogBusy = false;
    }

    addOrganization() {
        this.isEditing = false;
        this.selectedOrganization = {
            id: "",
            organizationId: "",
            name: "",
            wlextHost: "",
            wlextOrganizationId: null,
            logo: null,
            customInvitationText: null,
            categories: [],
            usersAssociated: 0,
            signupsCounter: [],
            downloadsCounter: [],
            lastMonthSignups: 0,
            lastMonthDownloads: 0,
            isActive: true,
            admin: null
        };
        this.selectedOrganizationAdmin = {username: "", password: ""};
        this.dialogActiveStep = 0;
        this.showDialog = true;
    }

    loadImage() {
        document.getElementById('input1')!.click();
    }

    parseImage(event: any) {
        const file = event.target.files[0];

        if (file) {
            const reader = new FileReader();

            reader.onload = (e: any) => {
                const result = e.target.result.split(",")[1];
                this.selectedOrganization!.logo = result;
            };

            reader.readAsDataURL(file);
        }
    }

    async continueSavingOrganization() {
        if (this.dialogActiveStep === 0) {
            if (this.selectedOrganization!.organizationId.trim() === "" ||
                this.selectedOrganization!.name.trim() === "" ||
                this.selectedOrganization!.wlextHost.trim() === "") {
                ElMessage.error("Compilare tutti i campi richiesti per continuare");
                return;
            }
            if (!this.isEditing &&
                (this.selectedOrganizationAdmin.username.trim() === "" ||
                this.selectedOrganizationAdmin.password === "")) {
                ElMessage.error("Compilare tutti i campi richiesti per continuare");
                return;
            }
            this.isDialogBusy = true;
            try {
                const categories = await CategoryService.getCategories(this.selectedOrganization!.wlextHost, this.selectedOrganization!.wlextOrganizationId);
                this.categories = categories.map(x => ({
                    ...x,
                    availabilityDays: this.selectedOrganization!.categories.find(y => y.name === x.name)?.availabilityDays ?? 45,
                    conditions: this.selectedOrganization!.categories.find(y => y.name === x.name)?.conditions ?? [],
                    selected: this.selectedOrganization!.categories.find(y => y.name === x.name) !== undefined
                }));
                this.dialogActiveStep = 1;
            } catch (error: any) {
                ElMessage.error({message: error.message});
            }
            this.isDialogBusy = false;
        } else {
            this.dialogActiveStep = 2;
        }
    }

    async saveOrganization() {
        this.isDialogBusy = true;
        try {
            this.selectedOrganization!.categories = this.categories.filter(x => x.selected).map(x => ({
                name: x.name,
                availabilityDays: x.availabilityDays,
                conditions: x.conditions
            }));

            if (!this.isEditing) {
                const organization = await OrganizationService.addOrganization(this.selectedOrganization!);
                await AdminService.addAdmin(organization.id, this.selectedOrganizationAdmin.username, this.selectedOrganizationAdmin.password);
                ElMessage.success({message: "Struttura configurata con successo"});
            } else {
                await OrganizationService.updateOrganization(this.selectedOrganization!);
                await AdminService.updateAdmin(this.selectedOrganization!.id, this.selectedOrganization!.admin!.username);
                ElMessage.success({message: "Struttura aggiornata con successo"});
            }

            this.showDialog = false;
            await this.getOrganizations();
        } catch (error: any) {
            ElMessage.error({message: error.message});
        }
        this.isDialogBusy = false;
    }

    getCategoryCheckboxStyle(category: Category) {
        return this.categoryFilter.trim() === "" || category.name.toLowerCase().includes(this.categoryFilter.trim().toLowerCase()) ? "inline-flex" : "none";
    }

    async updateOrganizationIsActive(organization: Organization) {
        this.isBusy = true;
        try {
            await OrganizationService.updateOrganization(organization);
        } catch (error: any) {
            organization.isActive = !organization.isActive;
        }
        this.isBusy = false;
    }

    changePassword() {
        ElMessageBox.prompt("Inserisci la nuova password", "Modifica password", {
            confirmButtonText: "Salva",
            cancelButtonText: "Annulla"
        }).then(async ({ value }) => {
            try {
                this.isDialogBusy = true;
                await AdminService.updateAdmin(this.selectedOrganization!.id, undefined, value);
                ElMessage.success({message: "Password modificata con successo"});
            } catch (error: any) {
                ElMessage.error({message: error.message});
            } finally {
                this.showDialog = false;
                this.isDialogBusy = false;
            }
        }).catch();
    }
}
</script>
